import { Link } from "react-router-dom";
import { EmptyState } from "../components/ui";

export function NotFoundPage() {
  return (
    <div>
      <EmptyState title="Page not found" description="The requested scheduling workspace does not exist." />
      <div className="mt-4 text-center"><Link className="button-primary" to="/">Return to dashboard</Link></div>
    </div>
  );
}
